import { SupportMessage } from '@bridebook/ui';
import { IconInfoCircle } from '@bridebook/ui/src/icons';
import { useTranslation } from 'next-i18next';
import { ILocationData } from '@bridebook/web/app-shared/lib/search/types';
import { FC, useMemo } from 'react';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { prettySupplierCategory } from '@bridebook/web/app-shared/lib/utils';
import { SearchType } from '@bridebook/toolbox/src/search-suppliers/types';
import { Slug, UrlFriendlySlug } from '@bridebook/toolbox/src/types';

interface IProps {
  locationName: string;
  locationData?: ILocationData | null;
  actualCategory: Slug | UrlFriendlySlug;
}

const SuppliersAroundWell: FC<IProps> = ({ locationName, locationData, actualCategory }) => {
  const { t } = useTranslation('search');
  const market = useMarket();
  const prettyCategory = useMemo(
    () =>
      prettySupplierCategory({
        slug: actualCategory,
        amount: 2,
        addWedding: true,
        capitalize: true,
        market,
        isLoggedIn: false,
      }),
    [actualCategory, market],
  );

  if (!locationData && !locationName) return null;

  const location =
    locationData?.type === SearchType.County
      ? locationData.county || locationData.country
      : locationData?.town || locationData?.name || locationName;

  return (
    <SupportMessage
      theme="primary"
      title={t('suppliersAroundLocation.title', { supplierType: prettyCategory, location })}
      icon={<IconInfoCircle width={16} />}>
      {t('suppliersAroundLocation.description', {
        supplierType: prettyCategory.toLowerCase(),
        location,
      })}
    </SupportMessage>
  );
};

export default SuppliersAroundWell;
